//
// Main
//
// Import this file using the following HTML or equivalent:
// <script src="dist/js/maps.min.js" type="text/javascript"></script>
//
// Example of usage
//
// {% if map_location %}
//  <div class="maps" data-zoom="5">
//      <div class="marker" data-lat="{{ map_location.lat }}" data-lng="{{ map_location.lng }}" data-marker-icon="{{ theme.link ~ '/dist/img/marker.png' }}">
//          <div class="maps__infobox">
//              <p>Infobox content</p>
//          </div>
//      </div>
//  </div>
// {% endif %}
//
( function ( $ ) {
	let mapsFunctions = {
		map: null,
		mapObj: null,
		options: null,
		markers: null,
		zoomLevel: null,

		init: function ( mapObj, options ) {
			// Variables
			let _this = this;

			_this.mapObj = mapObj;
			_this.options = options !== undefined ? options : {
			};
			_this.markers = mapObj.find( '.marker' );
			_this.zoomLevel = _this.mapObj.attr( 'data-zoom' ) !== undefined ? parseInt( _this.mapObj.attr( 'data-zoom' ) ) : 14;

			// Map options
			let args = {
				zoom: _this.zoomLevel,
				center: new google.maps.LatLng( 0, 0 ),
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				scrollwheel: false,
			};

			if ( _this.options.map !== undefined ) {
				$.extend( args, _this.options.map );
			}

			// Create map
			_this.map = new google.maps.Map( _this.mapObj[ 0 ], args );

			// Add a markers reference
			_this.map.markers = [];

			// Add markers
			_this.markers.each( function () {
				_this.addMarker( $( this ) );
			} );

			// Center map
			this.centerMap();
		},
		addMarker: function ( markerObj ) {
			// Variables
			let _this = this;
			let latlng = new google.maps.LatLng( markerObj.attr( 'data-lat' ), markerObj.attr( 'data-lng' ) );
			let cursor = $( '.maps__infobox', markerObj ).length > 0 ? 'pointer' : 'default';

			// Create marker
			let marker = new google.maps.Marker( {
				position: latlng,
				map: _this.map,
				cursor: cursor,
				icon: markerObj.attr( 'data-marker-icon' ),
			} );

			// Add to array
			_this.map.markers.push( marker );

			// If marker contains HTML, add it to an infobox
			if ( $( '.maps__infobox', markerObj ).length > 0 ) {
				// Infobox options
				let args = {
					content: `<div class="maps__infobox">${$( '.maps__infobox', markerObj ).html()}</div>`,
				};

				if ( _this.options.infobox !== undefined ) {
					$.extend( args, _this.options.infobox );
				}

				// Create infobox
				_this.map.markers[ _this.map.markers.length - 1 ].infobox = new google.maps.InfoWindow( args );

				// Show infobox when marker is clicked
				google.maps.event.addListener( _this.map.markers[ _this.map.markers.length - 1 ], 'click', function () {
					let currentMarker = this;

					$.each( _this.map.markers, function ( index, marker ) {
						// If marker is not clicked, close marker
						if ( _this.map.markers[ index ] !== currentMarker ) {
							_this.map.markers[ index ].infobox.close();
						}
					} );

					this.infobox.open( _this.map, this );
				} );
			}
		},

		centerMap: function () {
			// Variables
			let _this = this;
			let bounds = new google.maps.LatLngBounds();

			// Loop through all markers and create bounds
			$.each( _this.map.markers, function ( i, marker ) {
				let latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

				bounds.extend( latlng );
			} );

			// Only 1 marker?
			if ( _this.map.markers.length === 1 ) {
				// Set center of map
				_this.map.setCenter( bounds.getCenter() );
			} else {
				// Fit to bounds
				_this.map.fitBounds( bounds );
			}
		},
	};

	$.fn.maps = function ( options ) {
		if ( this.length > 0 ) {
			return mapsFunctions.init( this, options );
		}
	};
}( jQuery ) );
